import { PortableTextBlockComponent } from '@portabletext/react'
import React from 'react'

/**
 * Compact "serializer" (renderer) for inline text.
 * Does not apply any styling for text and color.
 */
export const InlineBlockSerializer: PortableTextBlockComponent = ({ children }) => (
  <>{children}</>
)
